import { useEffect, useState } from "react"

// Probes navigator.permissions for microphone without triggering the
// OS prompt. Returns one of: 'prompt' | 'granted' | 'denied' | 'unsupported'.
export function useMicPermission() {
  const [state, setState] = useState("unsupported")

  useEffect(() => {
    if (typeof navigator === "undefined") return
    if (!navigator.permissions || !navigator.permissions.query) {
      // Safari <16 — we'll just attempt getUserMedia directly when the
      // user taps the mic.
      setState("prompt")
      return
    }
    let cancelled = false
    let status

    navigator.permissions
      .query({ name: "microphone" })
      .then((result) => {
        if (cancelled) return
        status = result
        setState(result.state)
        result.onchange = () => {
          if (!cancelled) setState(result.state)
        }
      })
      .catch(() => {
        if (!cancelled) setState("prompt")
      })

    return () => {
      cancelled = true
      if (status) status.onchange = null
    }
  }, [])

  return state
}
